const Reducer = (state, action) => {
  switch (action.type) {
    case "SET_HIDDEN":
      return {
        ...state,
        hiddeSpinner: action.payload,
      };
    default:
      return state;
  }
};

export default Reducer;